import { graphql, useStaticQuery } from 'gatsby';
import { getImage, IGatsbyImageData } from 'gatsby-plugin-image';

import { LineItem } from '../types';
import { logError } from 'utils/helpers';

const useCartImage = (variant: LineItem): IGatsbyImageData | undefined => {
  const result = useStaticQuery(graphql`
    query {
      allContentfulProduct {
        nodes {
          displayName
          boxImage {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  `);
  const product = result.allContentfulProduct.nodes.find(
    matchProductToVariant(variant),
  );
  if (product) {
    return getImage(product.boxImage);
  } else {
    logError('could not match product to variant to get boxImage', {
      component: 'hooks/useCartImage',
      method: 'useCartImage',
      product,
      variant,
    });
  }
};

const matchProductToVariant =
  (variant: LineItem) =>
  (product: {
    displayName: string;
    // TODO: we should be matching on a more stable value, like slug/sku
  }) =>
    product.displayName === variant.product_name;

export default useCartImage;
